var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignupBluecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 9.19234C4.71817 10.0662 5.2456 11.1855 6.03711 12.065C6.25879 12.3113 6.53754 12.6264 6.70161 12.9135C6.87174 13.2112 7.07672 13.4043 7.32521 13.1282C7.72662 12.6822 8.06335 12.1549 8.49574 11.7225C9.20718 11.0111 9.83246 10.1372 10.6068 9.47347C11.1948 8.96941 11.5483 8.30195 12.084 7.76624C12.6493 7.20089 13.1703 6.54703 13.6532 5.9261C13.96 5.53166 14.4641 4.71303 14.8902 4.5",
    stroke: "#0075FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignupBluecheck);
export default __webpack_public_path__ + "static/media/icon-signup-bluecheck.4815825f3c9ba1a2735fd0dbfec803d4.svg";
export { ForwardRef as ReactComponent };